import { prop } from "ramda";
import { createSelector } from "reselect";

import type { OnlineOrderingState } from "packages/online_ordering/reducers/onlineOrdering";

const selectStoreInfo = state => state.storeInfo;
const selectCheckout = (state: OnlineOrderingState) => state.checkout;

const selectDeliveryGeojson = createSelector(
  selectStoreInfo,
  prop("deliveryGeojson")
);

const selectGiftCards = createSelector(
  selectCheckout,
  ({ payment: { giftCards } }) => ({
    giftCards,
  })
);

const selectGiftCardRequest = createSelector(
  selectCheckout,
  ({ payment: { giftCardsRequest } }) => ({
    giftCardsRequest,
  })
);

export { selectDeliveryGeojson, selectGiftCards, selectGiftCardRequest };
